import { render, staticRenderFns } from "./FlightItenary.vue?vue&type=template&id=86a4bf54"
import script from "./FlightItenary.vue?vue&type=script&lang=js"
export * from "./FlightItenary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports